import { queryOptions } from '@tanstack/react-query';
import { WalletPeriodSummaryQueryParamsType } from './walletPeriodSummaryQuery.type';
import { walletPeriodSummaryFunction } from './walletPeriodSummaryQueryFunction';

export const walletPeriodSummaryQueryOptions = (
  params: WalletPeriodSummaryQueryParamsType,
) => {
  return queryOptions({
    queryKey: ['wallet-period-summary', params],
    queryFn: () => walletPeriodSummaryFunction(params),
  });
};
